import { i18nFilter } from "app/filters/i18nFilter";
import {
    minAbbrNumberFilter,
    numberFilter,
    percentageSignFilter,
    percentageSignOnlyOrZeroFilter,
    timeFilter,
} from "app/filters/ngFilters";

export const getYaxisFormat = (metric: string, value: number, isPercentage: boolean) => {
    if (isPercentage) {
        return percentageSignOnlyOrZeroFilter()(value * 100, 0);
    }
    switch (metric) {
        case "TrafficShare":
            return minAbbrNumberFilter()(value);
        case "AverageDuration":
            return timeFilter()(value, null);
        case "PagesPerVisit":
            return numberFilter()(value, 2);
        case "BounceRate":
            return percentageSignFilter()(value, 2);
    }
};
export const getMetricTooltipHeader = (metric: string) => {
    switch (metric) {
        case "TrafficShare":
            return i18nFilter()("mmx.trafficshare.changetooltip.header");
        case "AverageDuration":
            return i18nFilter()("mmx.averageduration.changetooltip.header");
        case "PagesPerVisit":
            return i18nFilter()("mmx.pagespervisit.changetooltip.header");
        case "BounceRate":
            return i18nFilter()("mmx.bouncerate.changetooltip.header");
    }
};
